export const determineRoomNumbersTitle = (
  roomNumber: number,
  roomType: string,
  roomTypePlural: string
) => (roomNumber === 1 ? `1 ${roomType}` : `${roomNumber} ${roomTypePlural}`);
